import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import 'whatwg-fetch';
import { ThemeProvider, createGlobalStyle } from 'styled-components';

import App from 'App';
import theme from 'theme';
import analytics from 'lib/analytics';
import AuthProvider from 'lib/auth-provider';
import RouteProvider from 'lib/route-provider';

import robotoLight from 'fonts/Roboto-Light.ttf'
import robotoRegular from 'fonts/Roboto-Regular.ttf'
import robotoMedium from 'fonts/Roboto-Medium.ttf'
import robotoBold from 'fonts/Roboto-Bold.ttf'

import * as Sentry from '@sentry/react';

Sentry.init({ dsn: 'https://f9ce98600e084569bf56d226a1f525cb@sentry.io/1243085', environment: process.env.REACT_APP_SENTRY_ENV || "local" });

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: Roboto;
    src: url(${robotoLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: Roboto;
    src: url(${robotoRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: Roboto;
    src: url(${robotoMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }
  
  @font-face {
    font-family: Roboto;
    src: url(${robotoBold}) format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }
  
  html {
    box-sizing: border-box;
    font-size: 62.5%;
    height: 100%;
    
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    
    min-width: 320px;
  }
  
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    font-family: Roboto;
    font-weight: ${props => props.theme.fontWeightRegular};
    font-size: ${props => props.theme.fontSizeBase};
    line-height: ${props => props.theme.lineHeightBase};
    color: ${props => props.theme.primaryText};
    margin: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  #root {
    display: flex;
    flex: 0 1 100%;
    flex-direction: column;
    min-height: 100vh;
    max-width: 100vw;
    overflow-x: hidden;
  }

  a {
    color: #1EC2F2;
    text-decoration: none;
    word-wrap: break-word;

    &:hover {
      color: #C2EFFA;
    }
  }

  hr {
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-width: 0;
    border-top: 1px solid ${props => props.theme.border};
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 2rem;
    font-weight: 600;
    word-wrap: break-word;
    letter-spacing: 0.01rem;
  }

  ul, ol {
    padding-left: 0;
    margin-top: 0;
    ul, ol {
      padding-left: ${props => props.theme.paddingS};
      margin-top: ${props => props.theme.paddingXS};
      margin-bottom: ${props => props.theme.paddingS};
    }
  }

  li {
    margin-bottom: 1rem;
  }
  
  strong {
    font-weight: 600;
  }
  
  img,
  video {
    display: table;
    max-width: 100%;
  }
`

ReactDOM.render((
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Router>
      <RouteProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </RouteProvider>
    </Router>
  </ThemeProvider>
), document.getElementById('root'));

// Segment
(function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var t=analytics.methods[e];analytics[t]=analytics.factory(t)}analytics.load=function(e,t){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+e+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=t};analytics.SNIPPET_VERSION="4.1.0";
}})();
analytics.load();

// capture promise rejections
window.onunhandledrejection = function(evt) {
  if (evt && evt.reason) {
    Sentry.captureMessage(`Unhandled promise rejection ${JSON.stringify(evt.reason)}`, {
      extra: {
        event: evt,
      }
    })
  }
}
